<div data-testid="step-8-2-rfp-invitation-preview">
  <p-tabs
    appTabsUnsavedReveal
    [value]="activeTabIndex()"
    data-testid="rfp-invitation-tabs"
    (valueChange)="onTabChange($event!)"
    scrollable
  >
    <p-tablist data-testid="rfp-invitation-tablist">
      <p-tab
        [value]="0"
        [appTabStatus]="mailPreviewTabStatus.signal()"
        data-testid="rfp-mail-preview-tab"
      >
        {{ 'project.steps.rfp.invitationPreview.tabMailPreview' | transloco }}
      </p-tab>
      <p-tab
        [value]="1"
        [appTabStatus]="rfpProjectDescriptionTabStatus.signal()"
        data-testid="rfp-project-description-tab"
      >
        {{ 'project.steps.rfp.invitationPreview.tabProjectDescription' | transloco }}
      </p-tab>
    </p-tablist>
    <p-tabpanels class="mt-6" data-testid="rfp-invitation-tabpanels">
      <p-card data-testid="rfp-invitation-card">
        <p-tabpanel [value]="0" data-testid="rfp-mail-preview-tab-panel">
          @if (loadedTabs().has(0)) {
            <app-step-8-2-rfp-mail-preview
              [preloadedData]="invitationPreviewResponse()"
              (statusChange)="onMailPreviewStatusChange($event)"
            >
            </app-step-8-2-rfp-mail-preview>
          }
        </p-tabpanel>
        <p-tabpanel [value]="1" data-testid="rfp-project-description-tab-panel">
          @if (loadedTabs().has(1)) {
            <app-step-8-2-rfp-project-description
              [preloadedData]="invitationPreviewResponse()"
              (statusChange)="onRfpProjectDescriptionStatusChange($event)"
            >
            </app-step-8-2-rfp-project-description>
          }
        </p-tabpanel>
      </p-card>
    </p-tabpanels>
  </p-tabs>
</div>
